import Section from './ui/Section';
import Reveal from './ui/Reveal';
import api from '../assets/img/api.svg';
import eCommerce from '../assets/img/eCommerce.svg';
import cms from '../assets/img/cms.svg';
import webApp from '../assets/img/webApp.svg';
import gear from '../assets/img/gear.svg';
import target from '../assets/img/target.svg';
import lightbulb from '../assets/img/lightbulb.svg';
import bezier from '../assets/img/bezier.svg';

const SERVICES = [
  { icon: api, title: 'APIs', text: 'Individual programming of new, as well as implementation of existing APIs of all kinds.' },
  { icon: eCommerce, title: 'E-Commerce', text: 'Programming and setup, synchronization and relocation of stores including all assets and plugins.' },
  { icon: cms, title: 'CMS-Implementation', text: 'Creation of your own or assistance with content management systems.' },
  { icon: webApp, title: 'Webapplications', text: 'Programming web apps and other applications used on the web.' },
  { icon: gear, title: 'Admin & Hosting', text: 'Hosting of websites and the like, plus taking over system administration.' },
  { icon: target, title: 'IT-Consulting', text: 'Independent technology advice — architecture, stack choices and process, aligned to your goals.' },
  { icon: lightbulb, title: 'Custom solutions', text: 'Nothing off the shelf. The right software programmed only for your needs.' },
  { icon: bezier, title: 'Webdesign & UI/UX', text: 'Good programming needs smart design. We make applications intuitively understandable.' },
];

export default function Services() {
  return (
    <Section id="services" heading="Services" index="03">
      {/* Borderless editorial: icon + title + description in hairline-divided rows with
          generous whitespace. No boxes — cohesive with the Skills grid and page background.
          The top row of each column drops its divider. */}
      <div className="grid grid-cols-1 gap-x-16 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal
            key={s.title}
            delay={(i % 2) * 0.06}
            className="group flex gap-5 border-t border-hairline py-7 first:border-t-0 md:[&:nth-child(2)]:border-t-0"
          >
            <img
              src={s.icon}
              alt=""
              aria-hidden="true"
              loading="lazy"
              decoding="async"
              className="mt-1 h-9 w-9 shrink-0 object-contain opacity-70 brightness-0 invert motion-safe:transition motion-safe:duration-300 group-hover:opacity-100"
            />
            <div>
              <h3 className="font-gotham text-xl font-bold text-white lg:text-2xl">{s.title}</h3>
              <p className="mt-2 font-avenir text-brand-light-gray">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
